exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dashboardHeader-1e95d{display:flex;align-items:center}.rangePicker-6c04c{width:250px}", ""]);

// Exports
exports.locals = {
	"dashboardHeader": "dashboardHeader-1e95d",
	"rangePicker": "rangePicker-6c04c"
};